import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseSubscriberAdvertiserComponent } from '../../abstract-components/base-subscriber-advertiser.component';

@Component({
  selector: 'subscriber-advertiser-layout',
  standalone: false,
  templateUrl: './subscriber-advertiser-layout.component.html',
  styleUrl: './subscriber-advertiser-layout.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SubscriberAdvertiserLayoutComponent extends BaseSubscriberAdvertiserComponent {}
